document.addEventListener("DOMContentLoaded", function() {
  
  // --- UTILITY: View All / View Less Toggle (Keep original logic) ---
  const toggleBtn = document.getElementById("show-all-addons");
  if (toggleBtn) {
    toggleBtn.addEventListener("click", function() {
      const hiddenAddons = document.querySelectorAll(".addon-hidden");
      const isHidden = hiddenAddons[0].classList.contains("hidden");

      hiddenAddons.forEach(el => {
        el.classList.toggle("hidden", !isHidden);
      });

      toggleBtn.textContent = isHidden ? "View Less" : "View All";
    });
  }

  // --- CORE: Dynamic Add to Cart Interception ---
  
  // 1. Find the Add to Cart button using a reliable, static attribute: [name="add"]
  const addToCartButton = document.querySelector('button[name="add"]'); 

  if (!addToCartButton) {
    console.warn("Add to Cart button not found. Check the product page template.");
    return;
  }

  // 2. Extract the dynamic form ID from the button's 'form' attribute
  const dynamicFormId = addToCartButton.getAttribute('form');
  const form = document.getElementById(dynamicFormId);
  
  if (!form) {
    console.error(`Form with ID ${dynamicFormId} not found.`);
    return;
  }

  // **Action:** Intercept the button click
  addToCartButton.addEventListener("click", function(e) {
    
    
    // Stop the button's default submit action
    e.preventDefault(); 
    e.stopPropagation(); 
    
    addToCartButton.disabled = true;

    // --- Data Collection ---
    const formData = new FormData(form);

    const mainVariantId = formData.get("id");
    const mainQty = parseInt(formData.get("quantity") || 1, 10);

    if (!mainVariantId) {
        console.error("No main product variant selected! Cannot add to cart.");
        addToCartButton.disabled = false;
        return;
    }

    const items = [{ id: parseInt(mainVariantId, 10), quantity: mainQty }];

    // Add selected add-ons (fields must be named 'addon_ids[]')
    const addonIds = formData.getAll("addon_ids[]");
    addonIds.forEach(id => {
        const parsedId = parseInt(id, 10);
        if (!isNaN(parsedId)) {
            items.push({ id: parsedId, quantity: 1 });
        }
    });

    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
    })
    .then(res => {
        addToCartButton.disabled = false;
        
        if (!res.ok) {
            return res.json().then(errData => {
                throw new Error(errData.message || "Failed to add items to cart.");
            });
        }
        return res.json();
    })
    .then(data => {
         const newItemCount = data.items.reduce((total, item) => total + item.quantity, 0);

        const cartCountElement = document.querySelector('cart-count'); 
        if (cartCountElement && newItemCount !== undefined) {
            cartCountElement.textContent = newItemCount;
            
            cartCountElement.setAttribute('aria-label', `${newItemCount} items`);
            cartCountElement.removeAttribute('hidden');
            cartCountElement.style.display = 'block'; 

            if (newItemCount === 0) {
                cartCountElement.setAttribute('hidden', 'true');
            }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
                open: true 
            }
        }));

    })
    .catch(err => {
      console.error("Error adding items to cart:", err);
    });
  });
});